//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { date } from 'quasar'
import DateField from '../../components/Field/DateField.vue'
import { updateRecords } from './VehiclePropertyCostHistory.js'

const costRegExp = new RegExp('^-?\\d+(?:\.\\d{0,2})?')

export default {
  name: 'VehiclePropertyCostHistoryEditor',
  components: {
    DateField
  },
  props: {
    records: {
      type: Array,
      required: true
    },
    record: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateFormat: 'DD.MM.YYYY',

      isNew: !this.record,
      recordLocal: this.record ? Object.assign({}, this.record) : {
        value: null,
        fromTime: null,
        toTime: null
      }
    }
  },
  computed: {
    costValue: {
      get: function () {
        return this.recordLocal.value != null ? this.recordLocal.value : null
      },
      set: function (value) {
        if (value === '') {
          value = null
        } else if (value != null) {
          value = Number(value.toString().match(costRegExp)[0])
        }

        this.recordLocal.value = value
      }
    }
  },
  methods: {
    validateValue: function (val) {
      if (val == null) {
        return 'Обязательное поле'
      } else if (val < 0) {
        return 'Значение должно быть не меньше 0'
      }

      const fromDate = this.recordLocal.fromDate
      if (fromDate != null) {
        let prevCostRecord = null
        for (const costRecord of this.records) {
          if (costRecord != this.record) {
            if (costRecord.fromDate == null) {
              if (prevCostRecord == null) {
                prevCostRecord = costRecord
              }
            } else if (costRecord.fromDate < fromDate) {
              if (prevCostRecord) {
                if (prevCostRecord.fromDate == null || prevCostRecord.fromDate < costRecord.fromDate) {
                  prevCostRecord = costRecord
                }
              } else {
                prevCostRecord = costRecord
              }
            }
          }
        }
        if (prevCostRecord && prevCostRecord.value === this.costValue) {
          return 'Предыдущая по времени запись ' + (prevCostRecord.fromDate == null ? 'c пустым значением даты' : 'от ' + this.formatMillis(prevCostRecord.fromDate)) + ' имеет ту же цену'
        }
      }
      return true
    },
    validateFromDate: function (val) {
      if (typeof val === 'string') {
        val = this.parseMillis(val)
      }

      const sameDateRecord = this.records.find(record => record != this.record && record.fromDate == val)
      if (sameDateRecord) {
        return 'Запись ' + (val == null ? 'с пустым значением даты' : 'от ' + this.formatMillis(val)) + ' уже существует'
      }
      return true
    },
    formatMillis: function (millis) {
      if (millis) {
        return date.formatDate(millis, this.dateFormat)
      }
      return null
    },
    parseMillis (dateStr) {
      return date.extractDate(dateStr, this.dateFormat).getTime()
    },

    validate: function () {
      let valid = true
      valid &= this.$refs.cost.validate()
      valid &= this.$refs.fromDate.validate()
      return valid
    },
    onApply: async function () {
      if (!this.validate()) {
        return
      }

      if (this.isNew) {
        this.records.push(this.recordLocal)
      } else {
        Object.assign(this.record, this.recordLocal)
      }

      updateRecords(this.records, true)

      this.$emit('cancel')
    },
    onCancel: function () {
      this.$emit('cancel')
    }
  }
}
